import React from "react";

const ExpiringJobs = ({ expiringJobs }: any) => {

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-[#183853]">Jobs Expiring Soon</h2>
        <p className="text-gray-500 mt-1">
          Jobs that will expire in the next 7 days
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full border-separate border-spacing-y-2">
          <thead>
            <tr className="text-left text-gray-500 text-sm border-b border-gray-200">
              <th className="py-3 px-4 font-medium">Job Title</th>
              <th className="py-3 px-4 font-medium">Employer</th>
              <th className="py-3 px-4 font-medium">Type</th>
              <th className="py-3 px-4 font-medium">Live Date</th>
              <th className="py-3 px-4 font-medium">Expiry Date</th>
            </tr>
          </thead>

          <tbody>
            {(!expiringJobs || expiringJobs.length === 0) && (
              <tr>
                <td
                  colSpan={5}
                  className="py-4 px-4 text-center text-gray-500"
                >
                  No jobs expiring in the next 7 days.
                </td>
              </tr>
            )}

            {expiringJobs?.map((job: any, index: number) => (
              <tr
                key={job.id || index}
                className="bg-white hover:bg-gray-50 border-t border-gray-100"
              >
                <td className="py-3 px-4 text-[#183853] font-semibold">
                  {job.title}
                </td>
                <td className="py-3 px-4 text-[#183853]">{job.employer}</td>
                <td className="py-3 px-4">
                  <span
                    className={`inline-block px-3 py-1 text-sm font-semibold text-white rounded-full ${
                      job.type === "BPO" ? "bg-[#1E596D]" : "bg-[#183853]"
                    }`}
                  >
                    {job.type.split("_").join(" ")}
                  </span>
                </td>
                <td className="py-3 px-4 text-[#183853]">{job.liveDate}</td>
                <td className="py-3 px-4 font-medium text-[#F59E0B]">
                  {job.expiryDate}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

};

export default ExpiringJobs;
